import styled from 'styled-components';

import {
  DURATION,
  FONT_M,
  FONT_S,
  FONT_XS,
  HEIGHT_INPUT,
  HEIGHT_INPUT_M,
  HEIGHT_INPUT_NEW_M,
  HEIGHT_INPUT_S,
  RADIUS_S,
  Z_INDEX
} from '../../../../styles';
import { closeDropdownMenu, openDropdownMenu } from '../../../../utils/styleUtils';
import { IInputStyles } from '../../Input/ui/Input.styled';

export const Label = styled.div<IInputStyles>`
  font: ${(props) => {
    if (props.size !== undefined) {
      switch (props.size) {
        case 'l':
          return props.size ? FONT_M : FONT_S;
        case 'm':
          return props.size ? FONT_S : FONT_S;
        case 's':
          return props.size ? FONT_XS : FONT_S;
        default:
          return FONT_S;
      }
    } else {
      return FONT_S;
    }
  }};
  font-weight: 700;
  position: absolute;
  z-index: 2;
  line-height: 1.25rem;
  top: 22px;
  transform: translateY(-50%);
  transition-property: transform, font, height, color, letter-spacing, top;
  transition-duration: ${DURATION};
  transition-timing-function: ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  left: 1rem;
  text-overflow: ellipsis;
  display: block;
  user-select: none;
  color: ${(props) => props.theme.text.text01};
  pointer-events: none;
  will-change: transform;
`;
export const WrapperDropdown = styled.div<IInputStyles>`
  position: relative;
  flex: 1;
  width: ${(props) => (props.$width ? props.$width : '100%')};
  max-width: ${(props) => (props.$width ? props.$width : '100%')};
  border-radius: 5px;
  background: ${(props) => props.theme.newColor.base01};
  height: ${(props) => {
    if (props.size !== undefined) {
      switch (props.size) {
        case 'l':
          return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
        case 'm':
          return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
        case 's':
          return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
        case 'sm':
          return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
        default:
          return HEIGHT_INPUT_M;
      }
    } else {
      return HEIGHT_INPUT_M;
    }
  }};
  min-height: ${(props) => {
    if (props.size !== undefined) {
      switch (props.size) {
        case 'l':
          return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
        case 'm':
          return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
        case 's':
          return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
        case 'sm':
          return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
        default:
          return HEIGHT_INPUT_M;
      }
    } else {
      return HEIGHT_INPUT_M;
    }
  }};
  max-height: ${(props) => {
    if (props.size !== undefined) {
      switch (props.size) {
        case 'l':
          return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
        case 'm':
          return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
        case 's':
          return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
        case 'sm':
          return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
        default:
          return HEIGHT_INPUT_M;
      }
    } else {
      return HEIGHT_INPUT_M;
    }
  }};
  &.error {
    height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 's':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_S})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'sm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})`;
          default:
            return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
        }
      } else {
        return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
      }
    }};
    min-height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 's':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_S})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'sm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})`;
          default:
            return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
        }
      } else {
        return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
      }
    }};
    max-height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 's':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_S})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
          case 'sm':
            return props.size ? `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})` : `calc(0.25rem + 20px + ${HEIGHT_INPUT_NEW_M})`;
          default:
            return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
        }
      } else {
        return `calc(0.25rem + 20px + ${HEIGHT_INPUT_M})`;
      }
    }};
  }

  .dropdownArrow {
    color: ${(props) => props.theme.text.text01};
  }
  .custom-select__control {
    border: none !important;
    &:after {
      transition-property: color;
      transition-duration: ${DURATION};
      transition-timing-function: ease-in-out;
      color: ${(props) => props.theme.newColor.base08};
      position: absolute;
      inset: 0;
      content: '';
      border-radius: 5px;
      border: 1px solid currentColor;
      pointer-events: none;
    }
    width: 100%;
    max-width: 100%;
    background: transparent !important;
    position: relative;
    display: flex;
    border-radius: 5px;
    justify-content: space-between;
    outline: none !important;
    height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
          case 'm':
            return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
          case 's':
            return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
          case 'sm':
            return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
          default:
            return HEIGHT_INPUT_M;
        }
      } else {
        return HEIGHT_INPUT_M;
      }
    }};
    min-height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
          case 'm':
            return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
          case 's':
            return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
          case 'sm':
            return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
          default:
            return HEIGHT_INPUT_M;
        }
      } else {
        return HEIGHT_INPUT_M;
      }
    }};
    max-height: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? HEIGHT_INPUT : HEIGHT_INPUT_M;
          case 'm':
            return props.size ? HEIGHT_INPUT_M : HEIGHT_INPUT_M;
          case 's':
            return props.size ? HEIGHT_INPUT_S : HEIGHT_INPUT_M;
          case 'sm':
            return props.size ? HEIGHT_INPUT_NEW_M : HEIGHT_INPUT_M;
          default:
            return HEIGHT_INPUT_M;
        }
      } else {
        return HEIGHT_INPUT_M;
      }
    }};
    visibility: visible;
    align-content: center;
    text-align: inherit;
    color: ${(props) => props.theme.color.text01};
    transition-property: box-shadow, background;
    transition-duration: ${DURATION};
    transition-timing-function: ease-in-out;
  }
  .custom-select__control--menu-is-open {
  }
  .css-tj5bde-Svg {
    right: 0;
    top: 21px;
  }
  .custom-select__value-container {
    cursor: pointer;
    padding: 1.25rem 1rem 0;
    margin: 0;
    display: flex;
    align-items: center;
    height: 100%;
    border-width: 0;
    border-radius: inherit;
    background: none;
    caret-color: currentColor;
    word-break: keep-all;
  }
  .custom-select__single-value {
    text-overflow: initial;
    font: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? FONT_M : FONT_S;
          case 'm':
            return props.size ? FONT_S : FONT_S;
          case 's':
            return props.size ? FONT_XS : FONT_S;
          default:
            return FONT_S;
        }
      } else {
        return FONT_S;
      }
    }};
    line-height: 20px;
    margin: 0;
    font-weight: 700;
    color: ${(props) => props.theme.newColor.primary};
  }
  .custom-select__input-container {
    color: #999aa5 !important;
  }

  .custom-select__indicator-separator {
    display: none !important;
  }

  .custom-select__indicators {
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.newColor.black02};
    position: relative;
    justify-content: center;
    box-sizing: border-box;
    cursor: pointer;
    transition-property: opacity, transform;
    transition-duration: ${DURATION};
    transition-timing-function: ease-in-out;
    width: 2.75rem;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .custom-select__multi-value {
    background-color: ${(props) => props.theme.color.base03};
  }

  .custom-select__menu {
    background-color: ${(props) => props.theme.color.elevation01};
    padding: 5px;
    width: 100%;
    border-radius: 5px;
    isolation: isolate;
    pointer-events: auto;
    color: ${(props) => props.theme.text.text01} !important;
    position: absolute;
    border: none !important;

    font-size: 13px;
    right: 0;
    overflow-x: hidden;
    z-index: ${Z_INDEX};
    transform-origin: top;
    animation: ${openDropdownMenu} ${DURATION} ease;
    &.menu--close {
      animation: ${closeDropdownMenu} ${DURATION} ease;
    }
  }
  .custom-select__control--menu-is-open .custom-select__indicators {
    transform: rotate(180deg);
  }
  .css-mohuvp-dummyInput-DummyInput {
    position: absolute;
  }
  .custom-select__option {
    color: ${(props) => props.theme.text.text01};
    transition-property: background;
    transition-timing-function: ease-in-out;
    transition-duration: ${DURATION};
    border-radius: ${RADIUS_S};
    &.custom-select__option--is-focused {
      background: transparent;
      outline: none !important;
    }
    &.custom-select__option--is-selected {
      background-color: ${(props) => props.theme.newColor.grey02};
    }
    &:hover {
      background-color: ${(props) => props.theme.newColor.grey05};
    }
  }
  cursor: pointer;

  &.focused {
    .custom-select__control {
      box-shadow: none;
      &:after {
        border-width: 2px;
        color: ${(props) => props.theme.newColor.primary};
        box-shadow: none;
      }
    }
  }
  &.error {
    .custom-select__control {
      &:after {
        color: ${(props) => props.theme.text.negative};
      }
    }
  }
  &.focused ${Label}, &.filled ${Label} {
    z-index: 2;
    top: 18px;
    font: ${(props) => {
      if (props.size !== undefined) {
        switch (props.size) {
          case 'l':
            return props.size ? FONT_S : FONT_XS;
          case 'm':
            return props.size ? FONT_XS : FONT_XS;
          case 's':
            return props.size ? FONT_XS : FONT_XS;
          default:
            return FONT_XS;
        }
      } else {
        return FONT_XS;
      }
    }};
    position: absolute;
    line-height: 1.25rem;
    left: 1rem;
  }
  .custom-select__placeholder {
    visibility: hidden;
    margin: 0;
    font: ${FONT_S};
  }
  &.focused .custom-select__placeholder {
    visibility: visible;
    margin: 0;
  }
`;
